import { IComponentOptions, IOnChangesObjectOf } from "angular";
import { StateService } from "@uirouter/angular";
import { IWorkflowActions, IWorkflowUi } from "@gtmhub/goals/models";
import { applyWorkflowConditions, generateWorkflowUi } from "@gtmhub/goals/workflowUtils";
import { getCurrentUserId } from "@gtmhub/users";
import { IItemWorkflow } from "@webapp/okrs/goals/models/goal-workflow.models";

interface OkrWorkflowBindings {
  goalId: string;
  workflow: IItemWorkflow;
  actions: IWorkflowActions;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface OkrWorkflowCtrl extends OkrWorkflowBindings {}
class OkrWorkflowCtrl {
  public workflowUi: IWorkflowUi;
  public fake: { reviewers: string[] };

  public static $inject = ["$state"];

  constructor(private $state: StateService) {}

  public $onChanges(onChangesObj: IOnChangesObjectOf<OkrWorkflowBindings>): void {
    if (this.actions && this.workflow && (onChangesObj.actions || onChangesObj.workflow)) {
      this.workflowUi = applyWorkflowConditions(generateWorkflowUi(this.actions, this.workflow, getCurrentUserId()));
    }

    if (this.workflow && onChangesObj.workflow) {
      this.generateFakeWorkflowReviewers();
    }
  }

  public editReviewers(): void {
    if (this.workflowUi.owner) {
      this.$state.go("._approve.sendForApproval");
    }
  }

  public toggleReviewers(): void {
    this.workflowUi.showAllReviewers = !this.workflowUi.showAllReviewers;

    if (this.workflowUi.showAllReviewers) {
      this.workflowUi.limitReviewers = this.workflow.reviewers.length;
    } else {
      this.workflowUi.limitReviewers = this.workflowUi.defaultLimitReviewers;
    }
  }

  private generateFakeWorkflowReviewers(): string[] {
    const fakeUsersArr: string[] = [];

    if (!this.workflow || !this.workflow.reviewersNeeded || !this.workflow.reviewers) {
      return fakeUsersArr;
    }

    const reviewersAdded = this.workflow.reviewers.length;
    const fakeUsersCount = this.workflow.reviewersNeeded - reviewersAdded >= 0 ? this.workflow.reviewersNeeded - reviewersAdded : 0;
    for (let i = 0; i < fakeUsersCount; i++) {
      fakeUsersArr.push("");
    }

    this.fake = {
      reviewers: fakeUsersArr,
    };
  }
}

export const OkrWorkflowComponent: IComponentOptions = {
  template: require("./okr-workflow.component.html"),
  controller: OkrWorkflowCtrl,
  bindings: {
    goalId: "<",
    workflow: "<",
    actions: "<",
  },
};
